import { KMainFunctions } from "./main-functions";

export class TitleManager {
  private static pageTitle: string | null = null;

  public static updateTitle() {
    const isMainAI = KMainFunctions.isMainAI();
    if (!TitleManager.pageTitle) {
      document.title = isMainAI ? "Main Low Code" : "Kuika";
    }
    document
      .querySelector("link[rel='icon']")
      ?.setAttribute("href", isMainAI ? "/assets/main-ai/favicon_48x48.ico" : "/assets/favicon.ico");
  }

  public static setPageTitle(kuikaTitle: string, mainAITitle: string) {
    const isMainAI = KMainFunctions.isMainAI();
    TitleManager.pageTitle = isMainAI ? mainAITitle : kuikaTitle;
    document.title = TitleManager.pageTitle;
  }

  public static setPageMeta(description: string) {
    let meta = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.getElementsByTagName("head")[0]?.appendChild(meta);
    }
    meta.content = description;
  }

  public static clearPageTitle() {
    TitleManager.pageTitle = null;
  }
}
